import { $ } from '@/libs/jquery/index'

if (!$.rails) {
  // Загружаем только если не было определено ранее (вызовет исключение).
  import('jquery-ujs')
}
